import {
  SANS_4_5,
  UI_BODY,
  UI_BODY_BOLD_DF,
  UI_TITLE,
  getBreakPoint,
  useScreenWidth,
} from "oolib";
import React from "react";
import { Link } from "react-router-dom";
import { __CheckAccessToPrivatePlatform } from "../../../../../../../utils/accessControl";

import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";
import { usePlatformBuilderContext } from "../../../../../../../contexts/platformBuilderContext";
import { HeaderBreakpoint } from "@/CONSTANTS/hooks/useHeaderHeight";
export const HeaderLogo = ({ config, variant }) => {
  const {
    deployment: { _Logos = {} },
  } = config;

  const { user } = useGetQueryData("userData") || {};
  const { inGlobalNavBuilder } = usePlatformBuilderContext();
  const screenWidth = useScreenWidth();

  const {
    logo,
    logoShort,
    logoHeight,
    logoAltText,
    logoShortAltText,
    logoShortHeight,
    fallbackText,
    fallbackInitials,
  } = _Logos;

  const MD = screenWidth >= getBreakPoint(HeaderBreakpoint);

  const getLogoHeight = () => {
    if (variant === "short") {
      return !logoShortHeight || logoShortHeight > 63
        ? "100%" //which will take the height of the parent container i.e 40px
        : `${logoShortHeight}px`;
    } else if (screenWidth >= MD) {
      return !logoHeight || logoHeight > 53
        ? "100%" //which will take the height of the parent container i.e 40px
        : `${logoHeight}px`;
    } else {
      return !logoShortHeight || logoShortHeight > 63
        ? "100%" //which will take the height of the parent container i.e 40px
        : `${logoShortHeight}px`;
    }
  };

  const genLogo = () => {
    if (logo) {
      return (
        <img
          style={{ height: getLogoHeight() }}
          src={variant === "short" ? logoShort : MD ? logo : logoShort}
          alt={
            variant === "short"
              ? logoShortAltText
              : MD
              ? logoAltText
              : logoShortAltText
          }
        />
      );
    } else {
      //fallback text
      return (
        <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
          <UI_TITLE semibold>
            {MD
              ? fallbackText || "Open Knowledge Framework"
              : fallbackInitials || "OKF"}
          </UI_TITLE>
        </div>
      );
    }
  };

  const logoShellStyle = {
    height: "3.5rem",
    display: "flex",
    alignItems: "center",
    marginRight: "1.2rem",
  };

  return __CheckAccessToPrivatePlatform(user) ? (
    inGlobalNavBuilder ? (
      <div style={logoShellStyle}>{genLogo()}</div>
    ) : (
      <Link style={logoShellStyle} to="/">
        {genLogo()}
      </Link>
    )
  ) : (
    <div style={logoShellStyle}>{genLogo()}</div>
  );
};
